<template>
  <div class="page-header">
    <div-container class="has-text-centered" padding-top="1rem" padding-bottom="1rem">
      <div class="columns is-gapless is-centered is-vcentered is-multiline">
        <div class="column is-narrow has-text-left">
          <h1 class="main-header" style="padding:0 15px;">{{ title }}</h1>
        </div>
        <div class="column subnav-links">
          <slot></slot>
        </div>
      </div>
    </div-container>
  </div>
</template>

<script>
import DivContainer from '@/components/DivContainer'
export default {
  name: 'page-header',
  props: ['title'],
  components: {
    DivContainer
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    refresh: function () {
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// page-header

.page-header {
  width: 100%;
  // background-color: rgba(0,0,0,0.5);
  position: absolute;
  bottom: 0;

  .main-header {
    font-size: 4em;
    line-height: 1.2em;
  }

  h1, h2, h3, h4, h5, h6 {
    display: inline-block;
    // padding: 0px 15px;
    color: $color-white;
    // font-size: 1.8rem;
    font-family: $font-family-title;
    text-transform: uppercase;
    letter-spacing: 0;

    @media screen and (min-width: $tablet) {
      // font-size: 2.2rem;
    }
  }

  h1 {
    font-size: 1.8rem;
    @media screen and (min-width: $tablet) {
      font-size: 2.2rem;
    }
  }

  a > .text {
    color: $color-white;

    &:hover {
      color: $color-gray-light;
    }
  }

  .subnav-links {
    text-align: left;
    @media screen and (min-width: $tablet) {
      text-align: right;
    }

    .columns.is-gapless > .column {
      padding: 15px;

      &.subnav-item {
        max-width: 90px;
        @media screen and (min-width: $tablet) {
          max-width: 120px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// PageHeader.vue?1eac2b49